import type { PriceListHistoryEntry } from './queryCustomPriceListHistory';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const defaultPriceListHistoryQueryAtom = createQueryAtomFactory(
  'brokerage.defaultPriceListHistory',
  (params: { id: string }) => ({
    pricingDefaultPriceListHistory: {
      __args: { id: params.id },
      id: true,
      eventName: true,
      metadata: {
        occurredOn: true,
      },
      createdByUser: {
        id: true,
        firstName: true,
        lastName: true,
      },
      payload: true,
    },
  }),
  {
    select: (data): PriceListHistoryEntry[] => {
      if (!data?.pricingDefaultPriceListHistory) return [];
      return data.pricingDefaultPriceListHistory.map((event) => {
        let parsedPayload: Record<string, unknown> = {};
        try {
          parsedPayload =
            typeof event.payload === 'string'
              ? JSON.parse(event.payload)
              : ((event.payload as Record<string, unknown>) ?? {});
        } catch {
          parsedPayload = {};
        }

        const eventType = Object.keys(parsedPayload)[0] ?? event.eventName;

        return {
          id: event.id,
          eventType,
          occurredOn: event.metadata.occurredOn,
          createdByName: event.createdByUser
            ? `${event.createdByUser.firstName ?? ''} ${event.createdByUser.lastName ?? ''}`.trim()
            : 'System',
          payload: parsedPayload,
        };
      });
    },
  },
);
